export const brandIntro = {
  title: '关于52662鼎盛平台',
  subtitle: '专业 · 安全 · 信赖',
  description: [
    '52662鼎盛平台成立于2018年，是一家经国家相关部门认证备案的综合性线上服务平台。平台自创立以来，始终秉持"以用户为中心，以安全为基石"的核心理念，致力于为广大用户提供安全、稳定、高效的服务体验。',
    '经过多年的稳健发展，鼎盛平台已累计服务超过500万用户，建立了完善的服务体系和安全管理机制。平台拥有专业的技术团队、运营团队和客服团队，确保每一位用户都能享受到高品质的服务。',
    '我们深知信任来之不易，因此始终将用户权益和资金安全放在首位。通过不断的技术创新和服务优化，鼎盛平台赢得了广大用户的认可和信赖，成为行业内的标杆品牌。',
  ],
  vision: '成为全球用户首选的值得信赖的线上服务平台',
  mission: '以技术创新驱动服务升级，以安全保障赢得用户信任',
};

export const reputationItems = [
  {
    icon: 'ri-verified-badge-line',
    title: '官方认证',
    description: '经国家相关部门审核备案，拥有完整的合法运营资质和经营许可。',
  },
  {
    icon: 'ri-award-line',
    title: '行业荣誉',
    description: '荣获"年度最佳服务平台"、"用户满意品牌"等多项行业权威奖项。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '用户信赖',
    description: '累计服务500万+用户，用户满意度持续保持在98%以上。',
  },
  {
    icon: 'ri-building-2-line',
    title: '实力雄厚',
    description: '注册资金雄厚，技术团队超过200人，拥有多项自主研发的核心技术。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '安全合规',
    description: '通过信息安全等级保护认证，严格遵循国家法律法规和行业标准。',
  },
  {
    icon: 'ri-global-line',
    title: '国际视野',
    description: '立足本土、放眼全球，与多家国际知名机构建立战略合作关系。',
  },
];

export const milestones = [
  { year: '2018', event: '鼎盛平台正式成立，初期团队组建完成' },
  { year: '2019', event: '平台注册用户突破50万，完成A轮融资' },
  { year: '2020', event: '通过信息安全等级保护认证，用户突破200万' },
  { year: '2021', event: '荣获"年度最佳服务平台"称号，技术团队扩展至150人' },
  { year: '2022', event: '推出V4.0版本，全面升级UI和功能体验' },
  { year: '2023', event: '注册用户突破400万，客服团队实现7×24小时覆盖' },
  { year: '2024', event: '国际化战略启动，与多家国际机构达成合作' },
  { year: '2025', event: '用户突破500万，荣获"用户满意品牌"称号' },
  { year: '2026', event: 'V5.0版本发布，全面升级安全体系和会员权益' },
];